// @flow
import type { StoreResourceDef } from 'app/core/types'

export const groups: StoreResourceDef<> = {
  resourceType: 'groups',
}
